import { Norwegian } from './../../Localization/no.js';
import { English } from './../../Localization/en.js';

var cookie = readCookie('lang');
var currentLang = cookie ? cookie : ((navigator.language == 'nb' ? Norwegian.LANGUAGE_KEY : navigator.language) || navigator.userLanguage);
var languages = new Map();
languages.set(Norwegian.LANGUAGE_KEY, Norwegian);
languages.set(English.LANGUAGE_KEY, English);

function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

export function SetCurrentLanguage(newLang) {
  currentLang = newLang;
  document.cookie = 'lang=' + currentLang + ';';
}

export function Translate(key) {
  if (!languages.get(currentLang)) {
    currentLang = English.LANGUAGE_KEY; //Fallback to english...
  }

  return languages.get(currentLang)[key];
}


/** WEBPACK FOOTER **
 ** app/components/common/translator.js
 **/